module.exports = __webpack_public_path__ + "img/31_23.e9fd3e38.png";